module.exports = __webpack_public_path__ + "img/romania.a994210a.png";